import * as types from '../actionTypes';

const initialState = {
  thematics: [],
  categories: [],
  materialTypes: [],
  loading: false,
  error: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {

    case types.FETCH_THEMATICS_REQUEST:
      return {...state, loading: true, error: null};
    case types.FETCH_THEMATICS_SUCCESS:
      return {...state, loading: false, thematics: action.thematics, error: null};
    case types.FETCH_THEMATICS_FAILURE:
      return {...state, loading: false, error: action.error};

    case types.FETCH_CATEGORIES_REQUEST:
      return {...state, loading: true, error: null};
    case types.FETCH_CATEGORIES_SUCCESS:
      return {...state, loading: false, categories: action.categories, error: null};
    case types.FETCH_CATEGORIES_FAILURE:
      return {...state, loading: false, error: action.error};

    case types.FETCH_MATERIAL_TYPES_REQUEST:
      return {...state, loading: true, error: null};
    case types.FETCH_MATERIAL_TYPES_SUCCESS:
      return {...state, loading: false, materialTypes: action.materialTypes, error: null};
    case types.FETCH_MATERIAL_TYPES_FAILURE:
      return {...state, loading: false, error: action.error};

    default:
      return {...state};
  }
};

export default reducer;